import Root from '@/component/message/custom/component/root/index.vue';
import Container from '@/component/message/custom/component/container/index.vue';
import ConstrainedBox from '@/component/message/custom/component/constrainedBox/index.vue';
import Column from '@/component/message/custom/component/column/index.vue';
import Expanded from '@/component/message/custom/component/expanded/index.vue';
import ImageNode from '@/component/message/custom/component/image/index.vue';
import Positioned from '@/component/message/custom/component/positioned/index.vue';
import Row from '@/component/message/custom/component/row/index.vue';
import SizedBox from '@/component/message/custom/component/sizedBox/index.vue';
import Spacer from '@/component/message/custom/component/spacer/index.vue';
import Stack from '@/component/message/custom/component/stack/index.vue';
import TextNode from '@/component/message/custom/component/text/index.vue';
import KKButton from '@/component/message/custom/component/KKButton/index.vue';
import { logger } from '_c/util/logger';
import {
  CustomMessageBaseComponent,
  CustomMessageMayItem,
  CustomMessageRootComponent,
  CustomMessageType,
  ReportData,
} from '_c/typings/model/chat/text-node';
import { defineComponent, h, PropType, resolveComponent, VNode } from 'vue';
import { useRenderV2 } from './render-v2';


export default defineComponent({
  name: 'CustomMessageView',
  components: {
    Root,
    Container,
    ConstrainedBox,
    Column,
    Expanded,
    ImageNode,
    Positioned,
    Row,
    SizedBox,
    Spacer,
    Stack,
    TextNode,
    KKButton,
  },
  props: {
    customInfo: { type: String, required: true, default: '' },
    reportInfo: {
      type: Object as PropType<ReportData>,
      required: true,
    },
  },

  setup(props) {
    let rootComponentData: CustomMessageRootComponent|undefined;
    try {
      rootComponentData = JSON.parse(props.customInfo);
      // logger.info('自定义数据接受成功', customData);
    } catch {
      logger.error(
        'component-message-custom',
        `transfer error: ${props.customInfo}`,
      );
    }
    let scale = 1 / 2;
    const { width } = window.screen;
    if (rootComponentData?.adaptWidth) {
      scale = width / rootComponentData.adaptWidth;
    }

    if (!rootComponentData) {
      return h('p', '消息格式不支持');
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (rootComponentData.version > 1 || (rootComponentData as Record<string, any>)?.templateId) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return useRenderV2(rootComponentData as Record<string, any>);
    }
    return () => createEle(rootComponentData as CustomMessageRootComponent, h, props.reportInfo, scale);
  },
});

/**
 *
 * @param obj 界面json数据
 * @param c createElement方法
 */
function createEle(
  obj: CustomMessageMayItem,
  createElement: typeof h,
  reportData: ReportData,
  scale?: number,
): VNode {
  // 传入json对象和createElement方法
  let child: VNode|unknown = null;
  let type = '';
  // 定义子元素
  if (obj.child) {
    // 有子元素的情况下递归调用
    child = [createEle(obj.child, h, reportData, scale)];
  } else if (Array.isArray(obj.children)) {
    // 有多个子元素时,处理成数组
    const typeArr = obj.children.map(item => item.type);
    const isCon = typeArr.find(item => item === 'Container');
    const isExp = typeArr.find(item => item === 'Expanded');
    let tempChild: CustomMessageBaseComponent[];
    const tempObj: CustomMessageMayItem = JSON.parse(JSON.stringify(obj));
    if (isCon && isExp) {
      tempChild = obj.children.map(item => ({ ...item, usedWidth: true }));

      tempObj.children = tempChild;
    }
    child = (tempObj.children as CustomMessageBaseComponent[]).map(item => createEle(item, h, reportData, scale));
  }

  // 命名替换
  if (obj.type === CustomMessageType.Text) {
    type = 'TextNode';
  } else if (obj.type === CustomMessageType.Image) {
    type = 'ImageNode';
  } else {
    type = obj.type;
  }
  // 需要处理数据对象

  const attrObj = generateAttr(obj, reportData, scale);
  return createElement(
    // type, // 组件名
    resolveComponent(type), // 组件名
    attrObj, // 数据对象,除了type,child,children
    () => child, // 子组件
  );
}

function generateAttr(attr: CustomMessageMayItem, reportData: ReportData, scale?: number) {
  const temp = {
    attr: {
      ...attr,
      reportData,
    },
  };
  if (scale !== 1) {
    temp.attr.scale = scale;
  }
  return temp;
}
